import _ from 'lodash';
import config from '../package.json';
import { getAppModuleConfig } from '../../../selectors/configSelectors';
import { VhisAppModuleConfigType } from '../types/VhisConfig';

const emmaVhisModuleName = `emma-vhis`;

export const getDashboardPolicyApi = (state: {}): any => {
  const VhisAppModuleConfig: VhisAppModuleConfigType = getAppModuleConfig(
    state,
    emmaVhisModuleName,
  );
  if (!VhisAppModuleConfig) return null;
  return VhisAppModuleConfig.axaGoalDashboardPolicyListApi;
};

export const getDashboardPoliciesData = (state: {}): any => {
  const dashboardPolicies: any = _.get(
    state,
    `hk-emma-web-core/vhis.${config.dashboardReducerSubName}.dashboardPolicies`,
    [],
  );
  const policyTitle: string = _.get(
    state,
    `hk-emma-web-core/vhis.${config.dashboardReducerSubName}.policyTitle`,
    '',
  );
  const policyLength: number = _.get(
    state,
    `hk-emma-web-core/vhis.${config.dashboardReducerSubName}.policyLength`,
    0,
  );
  const isShowViewAllCard: boolean = _.get(
    state,
    `hk-emma-web-core/vhis.${config.dashboardReducerSubName}.isShowViewAllCard`,
    false,
  );
  const isShowTrackingDevice: boolean = _.get(
    state,
    `hk-emma-web-core/vhis.${config.dashboardReducerSubName}.isShowTrackingDevice`,
    false,
  );
  return {
    dashboardPolicies,
    policyTitle,
    policyLength,
    isShowViewAllCard,
    isShowTrackingDevice,
  };
};

export const getDashboardLoading = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/vhis.${config.dashboardReducerSubName}.isLoading`,
    false,
  );
};

export const getAxaGoalRules = (state: {}) => {
  const VhisAppModuleConfig: any =
    getAppModuleConfig(state, emmaVhisModuleName) || {};
  return VhisAppModuleConfig.axaGoalRules || {};
};

export const getAxaGoalLevel = (state: {}, calAchievedDays: any) => {
  const VhisAppModuleConfig: any =
    getAppModuleConfig(state, emmaVhisModuleName) || {};
  const axaGoalRules = VhisAppModuleConfig.axaGoalRules || {};
  const {
    crystalLevelDays,
    crystalTxtKey,
    jadeLevelDays,
    jadeTxtKey,
    diamondLevelDays,
    diamondTxtKey,
    newbieLevelDays,
    newbieTxtKey,
  } = axaGoalRules;
  const returnData: any = {};
  returnData.calAchievedDays = calAchievedDays;
  if (calAchievedDays >= crystalLevelDays && calAchievedDays < jadeLevelDays) {
    returnData.targetDays = jadeLevelDays;
    returnData.axaGoalLevel = crystalTxtKey;
    returnData.maxReached = false;
  } else if (
    calAchievedDays >= jadeLevelDays &&
    calAchievedDays < diamondLevelDays
  ) {
    returnData.targetDays = diamondLevelDays;
    returnData.axaGoalLevel = jadeTxtKey;
    returnData.maxReached = false;
  } else if (calAchievedDays >= diamondLevelDays) {
    returnData.targetDays = diamondLevelDays;
    returnData.axaGoalLevel = diamondTxtKey;
    returnData.maxReached = true;
  } else {
    returnData.targetDays = crystalLevelDays;
    returnData.axaGoalLevel = newbieTxtKey;
    returnData.maxReached = false;
  }
  return returnData;
};
